
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { ItiString } from '@/iti-core-vue';

@Component({})
export default class ItiSelectorItemsGroup extends Vue {
    @Prop() public items!: any[];
    @Prop({ default: false }) public justifyCenter!: boolean;
    @Prop({ default: false }) public xs12!: boolean;
    @Prop({ default: false }) public sm10!: boolean;
    @Prop({ default: false }) public sm6!: boolean;
    @Prop({ default: false }) public md6!: boolean;
    @Prop({ default: false }) public md4!: boolean;
    @Prop({ default: false }) public md3!: boolean;
    @Prop({ default: false }) public lg4!: boolean;
    @Prop({ default: false }) public lg3!: boolean;
    @Prop({ default: false }) public lg2!: boolean;
    @Prop({ default: '1.7' }) public aspectRatio!: string;
    @Prop({ default: 'red' }) public imageProperties!: string;
    @Prop({ default: 'white--text display-4 text-xs-center' }) public letterProperties!: string;
    @Prop({ default: false }) public actionsHidden!: boolean;
    @Prop({ default: 'Nombre' }) public propertyName!: string;
    @Prop({ default: 'Descripcion' }) public propertyDescription!: string;
    @Prop({ default: 'Imagen' }) public propertyImage!: string;

    constructor() {
        super();
    }

    public select(item: any) {
        this.$emit('Select', item);
    }

    public getItemName(item: any) {
        return item == null ? ItiString.Empty : item[this.propertyName];
    }

    public getFirstLetterName(item: any) {
        return item == null || item[this.propertyName].length === 0 ? ItiString.Empty : item[this.propertyName].substring(0, 1);
    }

    public getItemDescription(item: any) {
        return item == null ? ItiString.Empty : item[this.propertyDescription];
    }

    public getItemImage(item: any) {
        return item == null ? ItiString.Empty : item[this.propertyImage];
    }

    public hasItemImage(item: any): boolean {
        return item != null && !ItiString.IsNullOrWhiteSpace(item[this.propertyImage]);
    }
}
